import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const BoldIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="currentColor"
    title={t`Bold`}
    {...props}
  >
    <Path
      fill="currentColor"
      d="M11.917 10.666A1.917 1.917 0 0 0 10 8.75H4.75v3.834H10a1.918 1.918 0 0 0 1.917-1.918Zm-.667-5.333a1.917 1.917 0 0 0-1.917-1.917H4.75V7.25h4.583a1.917 1.917 0 0 0 1.917-1.917Zm1.5 0c0 .902-.357 1.765-.991 2.405a3.414 3.414 0 0 1 .657 5.344A3.417 3.417 0 0 1 10 14.085H4.667a1.418 1.418 0 0 1-1.417-1.418V3.334a1.417 1.417 0 0 1 1.417-1.417h4.666a3.417 3.417 0 0 1 3.417 3.417Z"
    />
  </Icon>
);
